const COMPONENT_NAME = "collapsible-faq";
const CLASS_SELECTOR = ".CollapsibleFAQ";
const ANSWER_SELECTOR = ".CollapsibleFAQ-answer";
const INNER_SELECTOR = ".CollapsibleFAQ-answerInner";
const CLASS_OPEN = "is-open";

const instances = [];

function toggle(element) {
    element.classList.toggle(CLASS_OPEN);
    const isOpen = element.classList.contains(CLASS_OPEN);
    const container = element.querySelector(ANSWER_SELECTOR);
    const inner = element.querySelector(INNER_SELECTOR);
    container.style.height = (isOpen ? inner.offsetHeight : 0) + 'px';
}
function initialize(element, PageComponents) {
    element.addEventListener(
        'click',
        (e) => {
            e.stopPropagation();
            e.preventDefault();
            toggle(element);
        }
    );
    instances.push(element);

    if (Warframe && Warframe.addDataLayerListener) {
        Warframe.addDataLayerListener({
            element,
            event: 'click',
            payload: {
                event: 'accordion_click',
                creative_type: 'accordion',
                creative_title: 'open/close',
                creative_placement: Warframe.detectAnalyticsPlacement(element),
            },
            transform: (e, p) => {
                const isOpen = element.classList.contains('is-open');
                p.creative_title = isOpen ? 'open' : 'close';
            },
        })
    }
}

module.exports = {
    name: COMPONENT_NAME,
    instances,
    initialize
};
